import { AsyncPageSection } from '@services';

// used to associate normal tabs within sections for deep-linking
// TODO: some child ids appear to be set in BR. May need to review this for Intl sites
export const PRODUCT_PAGE_SECTIONS: AsyncPageSection[] = [
  {
    id: 'overview',
    childIds: ['fund-description', 'meet-your-manager', 'strategy-&-benefits'],
  },
  {
    id: 'performance',
    childIds: [
      'annualized',
      'calendar-year',
      'cumulative',
      'discrete',
      'risk-measures',
      'risk-return-profile',
    ],
  },
  {
    id: 'attribution',
    childIds: [
      'attribution-tab-quarterly',
      'attribution-tab-twelve-month-rolling',
      'attribution-tab-ytd',
      'attribution-tab-calendar-year',
    ],
  },
  {
    id: 'portfolio',
    childIds: [
      'asset-allocation',
      'geographic-breakdown',
      'sector-allocation',
      'currency-breakdown',
      'market-capitalisation-breakdown',
      'portfolio-exposure',
      'strategy-breakdown',
      'asset-class-exposure',
      'average-portfolio-exposure',
      'fund-measures',
      'geographic-exposure',
      'sector-exposure',
      'security-type-exposure',
      'portfolio-risk-and-return-analysis',
      'top-long-exposures',
      'top-short-exposures',
      'manager-roster',
      'maturity-allocation',
      'quality-allocation',
      'fund-portfolio',
      'holdings',
      'top-ten-holdings-money-funds',
      'top-ten-holdings',
    ],
  },
  {
    id: 'distributions',
    childIds: [
      'distribution',
      'fund-tax',
      'view-historical-distributions-data',
    ],
  },
  {
    id: 'pricing',
    childIds: ['view-historical-pricing', 'historische-preise'],
  },
  { id: 'commentary', childIds: [] },
  { id: 'press-releases', childIds: [] },
  { id: 'documents', childIds: ['regulatory-documents', 'fund-literature'] },
  { id: 'marketing-content', childIds: [] },
  { id: 'morningstar-rated-funds', childIds: [] },
  { id: 'important-legal-info', childIds: [] },
];
